module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Paul Park\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("PAUL PARK lives in North Adams, MA")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/3FgQRy/tc-custom/9781466839373.jpg?1724535527320",
      "alt": "This image is the cover for the book Tourmaline, A Princess of Roumania"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Tourmaline, A Princess of Roumania\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The sequel to Park's stunning fantasy debut, "), _c('i', [_vm._v("A")]), _c('i', [_vm._v("Princess of Roumania")]), _vm._v("."), _c('br'), _vm._v("Teenager Miranda Popescu is at the fulcrum of a deadly political and diplomatic battle between conjurers in an alternate fantasy world where \"Roumania\" is a leading European power. Miranda was hidden by her aunt in our world. An American couple adopted and raised her in their quiet Massachusetts college town, but she had been translated by magic back to her own world, and is at large, five years in the future."), _c('br'), _vm._v("The mad Baroness Ceaucescu in Bucharest, and the sinister alchemist, the Elector of Ratisbon, who holds her true mother prisoner in Germany are her enemies. This is the story of how Miranda -- separated from her two best friends, Peter and Andromeda who have been left behind in the forests of an alternate America -- begins to grow into her own personality. And how Peter and Andromeda are shockingly changed in the process of making their way to Roumania to find Miranda again at the end of this book. "), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v("At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    A Tom Doherty Associates Book\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0